let i = 0;

const EVENTS = {
  LOADER_PROGRESS: i++,

  ATTACH: i++,
  ATTACHED: i++,
  RESIZE: i++,

  LOADED: i++,

  MOUSE_MOVE: i++,

  TICK: i++,
  RENDER: i++,
};

const EVENTS_MAP = Object.fromEntries(
  Object.entries(EVENTS).map(([key, value]) => [
    value,
    `on${key
      .toLowerCase()
      .split('_')
      .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
      .join('')}`,
  ])
);

const STORE_KEYS = {
  ZOOM_DISABLED: i++,
  PAN_DISABLED: i++,
  CONTROLS_DISABLED: i++,
  PARALLAX_DISABLED: i++,
  CAMERA_ZOOM: i++,
  CAMERA_POSITION: i++,
  KONG_ROTATION: i++,
};

export { EVENTS, EVENTS_MAP, STORE_KEYS };
